/**
 * Formats a number for display.
 * @param i the number to format.
 * @param decimals maximum number of decimal places to include; defaults to 2.
 */
export function formatNumber(i, decimals = 2) {
    const a = Math.abs(i);
    if (a >= 1e10 || (i !== 0 && a < 0.001))
        return i.toExponential(decimals);
    if (i === Math.floor(i))
        return i.toLocaleString();
    return i.toFixed(decimals).toLocaleString();
}
